import { positionAutofill, StopByStopTrip_autofill } from "../../util/autofill_scripts";
import { reverseGeocode } from "../../util/user_api";

export function init_searchEvent_listeners() {
    $(document).on("focus", ".stop-by-stop-input", function(event)
	{

		$("#stop-by-stop-autofill").show();
		if (! $("#autofill_results").html().length) $("#user-locations-wrapper").show();
		else $("#autofill_results").removeClass("d-none");
		let linkedInputElement:JQuery<HTMLElement> = $(event.target);
		let $autofill_results:JQuery<HTMLElement> = $("#stop-by-stop-autofill").find("#autofill_results");

		const parentEl:JQuery<HTMLElement> = $("#stopByStop_searchSidebar");

		positionAutofill($autofill_results, linkedInputElement,parentEl)

		$autofill_results.parent().css("left", linkedInputElement.offset().left - parentEl.offset().left);
	});

	$(document).on("focusout", ".stop-by-stop-input", ()=>{$("#stop-by-stop-autofill:not(:hover)").hide();});

    let typingTimer: ReturnType<typeof setTimeout>;
	const doneTypingInterval = 250;
	$(document).on("keydown", ".stop-by-stop-input", (event: JQuery.KeyboardEventBase<any, any, any, any>) => {
		if (event.key == "Enter" || event.key == "Escape" || event.key == "Tab") {
			$("#stop-by-stop-autofill").hide();
		};
		clearTimeout(typingTimer);
		typingTimer = setTimeout(function() {
			$(".stop-by-stop-input").off("keydown");

			StopByStopTrip_autofill(event);
		}.bind(this),doneTypingInterval);
	});

    $(document).on("click", "#useHome", function() {
		let address:string = $("#useHome").attr("data");
		window.curAutofillInput.val(address);
		$("#stop-by-stop-autofill").hide();
	});

    $(document).on("click", "#getLocation", ()=> {
		if (!navigator.geolocation) {
			console.error(`Your browser doesn't support Geolocation`);
		}else{
			navigator.geolocation.getCurrentPosition((position)=>{
				$("#startLocation").attr("query_type","poi");
				$("#startLocation").attr("query_val", `${position.coords.latitude},${position.coords.longitude}`)

				reverseGeocode(position.coords.latitude, position.coords.longitude).then((address: any) => {
					window.curAutofillInput.val(address);
					$("#stop-by-stop-autofill").hide();
				}).catch(e => {
					const err = new Error(JSON.stringify(e));$("#exception_str").val(err.name + ";" + err.message + ";" + err.stack);
					$("#errorModal").modal("show");
				});
			}), ()=>{
				console.error(`Failed to get Geolocation`);
			};
		}
	});
};